export class User {
  email: string;
  password: string;
  newPassword: string;
  username: string;
  userRole: string;
  homeDirectory: string;
  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/models/user.ts